import { Component, type ErrorInfo, type ReactNode } from "react";

import { AIWidgetFetchLogPrefix } from "scmp-app/lib/ai-recommendation/consts";

type Props = {
  children: ReactNode;
  onError: () => void;
};

export class AiWidgetErrorBoundary extends Component<Props, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`${AIWidgetFetchLogPrefix} AiWidgetErrorBoundary caught:`, error, errorInfo);
    this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
